export const reports = {
  create: 'reports-db-created',
  calculate: 'reports-data-ready',

  'calculate-partners-data': 'partners-data-is-ready',
  'get-partners-overview': 'partners-report-overview-received',
  'get-partner-data': 'partner-report-data-received',

  'get-buildings-by-postcode': 'buildings-by-postcode-received',
  'get-buildings-overview': 'buildings-overview-received',
  'get-building-data': 'building-report-data-received',

  overview: 'reports-overview-received',
  locations: 'building-locations-received',
  'location-dynamic': 'location-dynamic-received',
  record: 'reports-record-received'
}
